<main role="main" class="not-home-page">
    <div class="container">
        <div class="row">
            <div class="col-md-12 index-up">
                <app-breadcrumb></app-breadcrumb>
                <h2>{{description?.Title}}</h2>
                <p *ngIf="!isclicked" class="text-primary size18 font-weight-semibold">{{description?.Contenu}}
                </p>
                <p *ngIf="!isclicked" class="font-weight-semibold text-uppercase">{{"concurrence.chercher" | translate}}</p>
                <form *ngIf="!isclicked" class="form-ap" #formFilter="ngForm">
                    <div class="form-row">
                        <div class="col-md-4">
                            <label for="tag">{{"AppelOffre.motscle" | translate}}</label>
                            <input ngModel name="Objet" class="form-control" id="Objet" type="text" placeholder="{{'AppelOffre.Saisissezmotcles' | translate}}">
                        </div>
                        <div class="col-md-4">
                            <label for="region">{{"AppelOffre.region" | translate}}</label>
                            <select ngModel name="Region" class="form-control" id="region">
                                <option value="">{{"AppelOffre.ChoisissezRegion" | translate}}</option>
                                <option *ngFor="let r of Region" [value]="r.ID">{{r.Title}}</option>
                            </select>
                        </div>
                        <!-- <div class="col-md-3">
                            <label for="categorie">{{"AppelOffre.categorie" | translate}}</label>
                            <select ngModel name="Domain" class="form-control" id="categorie">
                                <option value="">{{"AppelOffre.ChoisissezCatégorie" | translate}}</option>
                                <option *ngFor="let c of Categorie" [value]="c">{{c}}</option>
                            </select>
                        </div> -->
                        <div class="col-md-4">
                            <label  for="DatePlis">{{"AppelOffre.DateOuverture" | translate}}</label>
                            <input ngModel name="DatePlis" class="form-control" id="DatePlis" type="date" placeholder="Choisissez une date">
                        </div>
                    </div>
                    <button class="btn btn-info" [class.pr-5]="!isArab" [class.pl-5]="isArab" (click)="lancerFilter(formFilter.value)">{{"AppelOffre.LancerRecherche" | translate}}<span class="icon-search"></span></button>
                </form>
            </div>
        </div>
    </div>

    <div *ngIf="isclicked" class="container">
    <div class="row">
        <div class="col-md-3 side-bar">
        <div class="selected-item">      </div> 
        <nav id="sidebar">
          <app-statique-menu
            [lg]="outputLg"
            [cururl]="currentUrl"
          ></app-statique-menu>
        </nav>
      </div>
      <div class="col-md-9">
            <div *ngIf="isclicked" style="padding: 20px 2rem;">
                <div class="avis_ao">
                    <span>Détail de l'appel à la Concurrence</span>
                </div>
                <div class="tire_ao">
                    N° appel à la Concurrence
                </div>
                <div class="detail_ao">
                    <span>{{selectedOffre?.Title}} </span>
                </div>
                <div class="tire_ao">
                    Objet
                </div>
                <div class="detail_ao">
                    <span id="ctl00_ctl42_g_aca240e3_2a78_4630_894b_603800911dc2_ctl00_L_Objet">
                        {{capitize(selectedOffre?.Objet)}}
                    </span>
        
                </div>
                <!-- <div class="tire_ao">
                {{converteDate(selectedOffre?.Date_x0020_de_x0020_publication)}}
                </div>
                <div class="detail_ao">
                    <span>{{ converteDate(selectedOffre?.Date_x0020_limite_x0020_de_x0020)}}</span>
        
                </div> -->
                <div class="tire_ao">
                    Date d'ouverture de l'appel à la Concurrence
                </div>
                <div class="detail_ao">
                    <span>{{converteDate(selectedOffre?.Date_x0020_Ouverture)}}</span>
                </div>
        
                <div class="tire_ao">
                  Étape
              </div>
              <div class="detail_ao">
                  <span>{{selectedOffre?.Etape}}</span>
              </div>
                <div class="tire_ao" *ngIf="selectedOffre?.AttachmentFiles.length!=0">
                    Avis à télécharger
                </div>
                <div class="detail_ao">
                    <div *ngFor="let file of selectedOffre?.AttachmentFiles">
                        <a [href]="file.ServerRelativeUrl"> {{file.FileName}} </a><br>
                    </div>
                </div>
                <div class="tire_ao" *ngIf="selectedOffre?.AttachmentFiles.length!=0">
                    Dossier de l'appel à la Concurrence
                </div>
                <div class="detail_ao">
                    <a *ngIf="dossierReady" href="#" class="text-primary" data-toggle="modal" data-target="#myModal">
                        Télécharger 
                    </a>
                      <p *ngIf="!dossierReady"> Dossier indisponible</p>
                      
                </div>
                <!-- <div class="faq">
                    <div *ngFor="let item of faqItems" class="faq-item">
                      <h3 class="questionFaq" (click)="toggleFaq(item)" [ngClass]="{'active': item.active}">
                        Télécharger le dossier
                      </h3>
                      <div class="repenseFaq" *ngIf="item.active">
                        Pour Télécharger le dossier merci de remplire le formulaire suivant : 
                        
                      </div>
                    </div>
                  </div> -->
                  <!-- Button to open the modal -->

  
            </div>
        
      </div>
    </div>
  </div>

    
    <section *ngIf="!isclicked" class="c-appels-offres">
        <div class="container">
            <div class="row">
                <div class="col d-flex justify-content-between">
                    <h2 class="size18 text-uppercase mb-3">{{"AppelOffre.ResultatRecherche" | translate}} : </h2>
                    <p class="size18 text-uppercase text-white mt-4 pt-1 mb-3">
                        {{lenth}}
                        {{"concurrence.AppelTrouve" | translate}}</p>
                </div>
            </div>
            <!-- <div class="row slickappel" data-aos="fade-up">
                <div *ngFor="let offres of dataOffres" class="col-md-12">
                    <a *ngFor="let offre of offres" routerLink="{{offre.ID}}"
                        class="block-appels d-flex align-items-start flex-column">
                        <div class="d-flex justify-content-between w-100">
                            <div class="num-appel-offre">{{offre.Title}}</div>
                            <div class="date-appels mt-auto">{{converteDate(offre.Date_x0020_de_x0020_publication)}} </div>
                        </div>
                        <h3 class="titre-appels size18"> {{offre.ObjetAppelOffre}} </h3>
                    </a>
                </div>
            </div> -->
            <table id="offres" class="table table-striped table-bordered" style="width:100%">
                <thead>
                    <tr>
                        <th>N° appel à la Concurrence</th>
                        <th>Objet</th>
                        <th>Étape</th>
                        <th>Date d'ouverture</th>
                    </tr>
                </thead>
            </table>
            <div class="row">
                <div class="col-md-12">
                    <p class="text-white size12 mt-4">{{descriptionFooter?.Contenu}}</p>
                    <p class="text-white size12" [innerHTML]="descriptionFooter?.Variables"></p>
                </div>
            </div>
        </div>
        
    </section>
</main>



<!-- Modal -->
<div class="modal fade" id="myModal" tabindex="-1" role="dialog" aria-labelledby="myModalLabel" aria-hidden="true">
    <div class="modal-dialog modal-dialog-centered" role="document">
      <div class="modal-content card border-primary shadow-lg mx-auto" style="max-width: 500px;">
        <!-- Card Header -->
        <div class="card-header bg-primary text-white">
            <button type="button" class="close text-white" data-dismiss="modal" aria-label="Close">
                <span aria-hidden="true" style="color: white;">&times;</span>
              </button>
          <h5 class="modal-title" id="myModalLabel">Merci de remplire le formulaire pour télécharger le dossier</h5>
          
        </div>
  
        <!-- Card Body -->
        <div class="card-body">
        <!-- Form starts here -->
<form #myForm="ngForm" (ngSubmit)="onSubmit(myForm)" novalidate>

    <!-- Nom et prénom -->
    <div class="form-group">
      <label for="fullName">Nom et prénom *</label>
      <input type="text" class="form-control" id="fullName" name="fullName" required [(ngModel)]="fullName">
      <div *ngIf="myForm.submitted && !myForm.controls['fullName']?.valid" class="text-danger">
        Ce champ est obligatoire.
      </div>
    </div>
  
    <!-- Qualité de la personne ayant retiré le dossier -->
    <div class="form-group">
      <label for="personQuality">Qualité de la personne ayant retiré le dossier *</label>
      <input type="text" class="form-control" id="personQuality" name="personQuality" required [(ngModel)]="personQuality">
      <div *ngIf="myForm.submitted && !myForm.controls['personQuality']?.valid" class="text-danger">
        Ce champ est obligatoire.
      </div>
    </div>
  
    <!-- Adresse email de la personne -->
    <div class="form-group">
      <label for="email">Adresse email *</label>
      <input type="email" class="form-control" id="email" name="email" required [(ngModel)]="email">
      <div *ngIf="myForm.submitted && !myForm.controls['email']?.valid" class="text-danger">
        Entrez une adresse email valide.
      </div>
    </div>
  
    <!-- Raison sociale de l’entreprise -->
    <div class="form-group">
      <label for="companyName">Raison sociale *</label>
      <input type="text" class="form-control" id="companyName" name="companyName" required [(ngModel)]="companyName">
      <div *ngIf="myForm.submitted && !myForm.controls['companyName']?.valid" class="text-danger">
        Ce champ est obligatoire.
      </div>
    </div>
  
    <!-- Adresse de l’entreprise -->
    <div class="form-group">
      <label for="companyAddress">Adresse de l’entreprise *</label>
      <input type="text" class="form-control" id="companyAddress" name="companyAddress" required [(ngModel)]="companyAddress">
      <div *ngIf="myForm.submitted && !myForm.controls['companyAddress']?.valid" class="text-danger">
        Ce champ est obligatoire.
      </div>
    </div>
  
    <!-- N° Téléphone de l’entreprise -->
    <div class="form-group">
      <label for="companyPhone">N° Téléphone de l’entreprise *</label>
      <input type="tel" class="form-control" id="companyPhone" name="companyPhone" required [(ngModel)]="companyPhone">
      <div *ngIf="myForm.submitted && !myForm.controls['companyPhone']?.valid" class="text-danger">
        Ce champ est obligatoire.
      </div>
    </div>
  
    <!-- Cocher les conditions d’utilisation et de confidentialité -->
    <div class="form-group form-check">
      <input type="checkbox" class="form-check-input" id="terms" name="terms" required [(ngModel)]="terms">
      <label class="form-check-label" for="terms">J'accepte <a routerLink="/acces-rapide/legalnotice" target="_blank"> les conditions d’utilisation et de confidentialité</a> *</label>
      <div *ngIf="myForm.submitted && !myForm.controls['terms']?.valid" class="text-danger">
        Vous devez accepter les conditions.
      </div>
    </div>
  
    <!-- Error message -->
    <div class="form-group form-check">
      <label style="color: red;" class="form-check-label" for="terms">{{error}}</label>
    </div>
  </form>
  <!-- Form ends here -->
  
        </div>
  
        <!-- Card Footer -->
        <div class="card-footer text-right">
          <button type="button" class="btn btn-secondary" data-dismiss="modal">Fermer</button> &nbsp;&nbsp;
          <button type="submit" class="btn btn-primary" [disabled]="!myForm.valid" (click)="onSubmit(myForm)">Envoyer</button>
        </div>
      </div>
    </div>
  </div>
  